/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const STREAM_TYPE_OPTIONS = optionsProxy.create([
  { value: 'udp', get label() { return i18n.t('lunaStreams:константы.stream type.udp'); } },
  { value: 'tcp', get label() { return i18n.t('lunaStreams:константы.stream type.tcp'); } },
  { value: 'videofile', get label() { return i18n.t('lunaStreams:константы.stream type.videofile'); } },
  { value: 'images', get label() { return i18n.t('lunaStreams:константы.stream type.images'); } },
]);

export const SENDING_TYPE_OPTIONS = optionsProxy.create([
  { value: 'sec', get label() { return i18n.t('lunaStreams:константы.sending type.sec'); } },
  { value: 'frames', get label() { return i18n.t('lunaStreams:константы.sending type.frames'); } },
]);

export const FRAME_PROCESSING_MODE_OPTIONS = optionsProxy.create([
  { value: 'auto', get label() { return i18n.t('lunaStreams:константы.frame processing mode.auto'); } },
  { value: 'full', get label() { return i18n.t('lunaStreams:константы.frame processing mode.full'); } },
  { value: 'scale', get label() { return i18n.t('lunaStreams:константы.frame processing mode.scale'); } },
]);

export const LIVENESS_MODE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('lunaStreams:константы.liveness mode.0'); } },
  { value: 1, get label() { return i18n.t('lunaStreams:константы.liveness mode.1'); } },
  { value: 2, get label() { return i18n.t('lunaStreams:константы.liveness mode.2'); } },
]);

export const STREAM_STATUS_OPTIONS = optionsProxy.create([
  { value: 'pending', get label() { return i18n.t('lunaStreams:константы.stream status.pending'); } },
  { value: 'in_progress', get label() { return i18n.t('lunaStreams:константы.stream status.in_progress'); } },
  { value: 'done', get label() { return i18n.t('lunaStreams:константы.stream status.done'); } },
  { value: 'pause', get label() { return i18n.t('lunaStreams:константы.stream status.pause'); } },
  { value: 'restart', get label() { return i18n.t('lunaStreams:константы.stream status.restart'); } },
  { value: 'cancel', get label() { return i18n.t('lunaStreams:константы.stream status.cancel'); } },
  { value: 'failure', get label() { return i18n.t('lunaStreams:константы.stream status.failure'); } },
  { value: 'handler_lost', get label() { return i18n.t('lunaStreams:константы.stream status.handler_lost'); } },
  { value: 'not_found', get label() { return i18n.t('lunaStreams:константы.stream status.not_found'); } },
  { value: 'deleted', get label() { return i18n.t('lunaStreams:константы.stream status.deleted'); } },
]);

export const CREATE_STREAM_STATUS_OPTIONS = optionsProxy.create([
  { value: 'pending', get label() { return i18n.t('lunaStreams:константы.stream status.pending'); } },
  { value: 'pause', get label() { return i18n.t('lunaStreams:константы.stream status.pause'); } },
]);

export const ROTATION_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return '0'; } },
  { value: 90, get label() { return '90'; } },
  { value: 180, get label() { return '180'; } },
  { value: 270, get label() { return '270'; } },
]);
